import axios from "axios";
import { END_POINT } from "config/environment";
import { useGetUserInfo } from "hooks/useGetUserInfo";
import { useQuery } from "react-query";



export const useGetEnterpriseDashboard = () => {

  const { token } = useGetUserInfo();

  const url = `${END_POINT.BASE_URL}/v1/enterprise-dashboard/metrics`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return useQuery(
    ["enterprise-dashboard"],
    async () => {
      const { data } = await axios.get(url, config);
      return data.data;
    },
    {
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
      refetchOnWindowFocus: false,
    }
  );
};

export const useGetRecruiterPerformance = (recruiterId: any) => {
  const { token } = useGetUserInfo();

  const url = `${END_POINT.BASE_URL}/v1/enterprise-dashboard/recruiter/${recruiterId}/performance`;
  const config = {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  };
  return useQuery(
    ["recruiter-performance", recruiterId],
    async () => {
      const { data } = await axios.get(url, config);
      return data.data;
    },
    {
      enabled: !!recruiterId,
      staleTime: 5 * 60 * 1000,
    }
  );
};